module.exports = __webpack_public_path__ + "static/Find Us Store 5-01-a2280bca7923350e6e7bc9833dbed57f.png";